// !Do not remove the Layout import
import Layout from '@layouts/HorizontalLayout'

const HorizontalLayout = props => <Layout {...props}>{props.children}</Layout>

export default HorizontalLayout
